var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appendix"},[_c('div',{staticClass:"title"},[_vm._v("附录")]),_c('div',{staticClass:"show-box"}),_c('div',{staticClass:"text"},[_c('p',[_vm._v("髓母细胞瘤分子分型相关意义")]),_c('p',[_vm._v("基因变异 Circos 图展示")]),_c('p',[_vm._v("基因列表")])])])
}]

export { render, staticRenderFns }